import * as React from 'react';

import {InboxCreditUsageFooter} from '../engagement/footer/inbox-credit-usage-footer';

import {CampaignsUsageFooter} from './campaigns-usage-footer';
import {NutshellIqUsageFooter} from './nutshell-iq-usage-footer';

export function MarketingFooter() {
    const path = window.location.pathname;

    const requiresIqCredits = path.includes('visitors') || path.includes('prospectoriq');
    if (requiresIqCredits) {
        return <NutshellIqUsageFooter />;
    }

    if (path.includes('sms')) {
        return <InboxCreditUsageFooter type='smsCampaigns' />;
    }

    return <CampaignsUsageFooter />;
}
